import React, { useState } from "react";
import axios from "axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ type: null, text: "" });

  const handleForgotPassword = async () => {
    if (!email.trim()) {
      setState({ type: "err", text: "Merci de saisir votre adresse e-mail." });
      return;
    }

    try {
      await axios.post("/api/v1/user/forgot-password", { email });
      setState({
        type: "ok",
        text:
          "Si un compte existe pour cet e-mail, un lien de réinitialisation vous a été envoyé.",
      });
    } catch (e) {
      setState({
        type: "err",
        text: "Une erreur est survenue. Réessayez dans un instant.",
      });
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") handleForgotPassword();
  };

  return (
    <>
      <h2 className="arena-title">Réinitialiser le mot de passe</h2>

      <label className="arena-label" htmlFor="fp-email">Adresse e-mail</label>
      <input
        id="fp-email"
        type="email"
        placeholder="vous@club.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={onKeyDown}
        className="arena-input"
        autoComplete="email"
      />

      {state.text &&
        (state.type === "err" ? (
          <p className="arena-error">{state.text}</p>
        ) : (
          <p style={{ color: "var(--muted)", margin: "4px 0 0", fontSize: 13 }}>
            {state.text}
          </p>
        ))}

      <button className="arena-primary" onClick={handleForgotPassword}>
        Envoyer le lien
      </button>
    </>
  );
}